/* Hydrate à la demande les sous-niveaux du drawer mobile.
   Pré-rendu côté serveur : seul niveau 1 (≈ 12 KB au lieu de 1.28 MB).
   À l'ouverture d'un <details data-drawer-lvl1-handle>, on remplit son
   <ul data-drawer-needs-hydration> avec les niveaux 2 et 3 depuis
   window.menuBhData (chargé async via menu-arbo.js). */
(function () {
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'})[c]; }); }

  // Index handle → noeud menuBhData
  var byHandle = null;
  function buildIndex() {
    if (byHandle) return byHandle;
    byHandle = {};
    if (typeof window.menuBhData !== 'object') return byHandle;
    var keys = Object.keys(window.menuBhData);
    for (var i = 0; i < keys.length; i++) {
      var n = window.menuBhData[keys[i]];
      if (n && n.handle) byHandle[n.handle] = n;
    }
    return byHandle;
  }

  function sortedChilds(node, lookup) {
    if (!node || !node.childs || !node.childs.length) return [];
    return node.childs
      .map(function (c) { return lookup[c.handle] || c; })
      .filter(function (c) { return c && c.display !== false; })
      .sort(function (a, b) { return (a.title || '').toLowerCase() < (b.title || '').toLowerCase() ? -1 : 1; });
  }

  // Crée un <li><a> simple (niveau feuille)
  function makeLeafLi(child) {
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '/collections/' + child.handle;
    a.className = 'menu-drawer__menu-item link link--text list-menu__item focus-inset';
    a.textContent = child.title;
    li.appendChild(a);
    return li;
  }

  // Crée un <li><details><summary>...</summary><div><ul></ul></div></details></li>
  // contenant les petits-enfants (niveau 3). Récursif sur 1 niveau de plus.
  function makeBranchLi(child, lookup) {
    var grand = sortedChilds(child, lookup);
    if (!grand.length) return makeLeafLi(child);
    var li = document.createElement('li');
    var det = document.createElement('details');
    var sum = document.createElement('summary');
    sum.className = 'menu-drawer__menu-item link link--text list-menu__item focus-inset';
    sum.textContent = child.title;
    det.appendChild(sum);
    var wrap = document.createElement('div');
    wrap.className = 'menu-drawer__submenu has-submenu gradient motion-reduce';
    var inner = document.createElement('div');
    inner.className = 'menu-drawer__inner-submenu';
    var close = document.createElement('button');
    close.className = 'menu-drawer__close-button bh-drawer-close link link--text focus-inset';
    close.textContent = '← ' + child.title;
    close.addEventListener('click', function () { det.removeAttribute('open'); });
    inner.appendChild(close);
    var ul = document.createElement('ul');
    ul.className = 'menu-drawer__menu list-menu';
    grand.forEach(function (g) { ul.appendChild(makeLeafLi(g)); });
    inner.appendChild(ul);
    wrap.appendChild(inner);
    det.appendChild(wrap);
    li.appendChild(det);
    return li;
  }

  function hydrate(details) {
    var ul = details.querySelector('ul[data-drawer-needs-hydration]');
    if (!ul) return;
    ul.removeAttribute('data-drawer-needs-hydration');
    var handle = details.getAttribute('data-drawer-lvl1-handle');
    var lookup = buildIndex();
    var node = lookup[handle];
    if (!node) {
      // Fallback : rien dans menuBhData → simple lien
      ul.innerHTML = '<li><a class="menu-drawer__menu-item link link--text" href="/collections/' + esc(handle) + '">Voir tout</a></li>';
      return;
    }
    var childs = sortedChilds(node, lookup);
    if (!childs.length) {
      ul.innerHTML = '<li><a class="menu-drawer__menu-item link link--text" href="/collections/' + esc(handle) + '">Voir tout</a></li>';
      return;
    }
    childs.forEach(function (c) { ul.appendChild(makeBranchLi(c, lookup)); });
  }

  function onToggle(e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS') return;
    if (!d.hasAttribute('data-drawer-lvl1-handle')) return;
    if (!d.hasAttribute('open')) return;
    hydrate(d);
  }

  document.addEventListener('toggle', onToggle, true);
  // Si menuBhData arrive après une ouverture, on rebuild l'index puis on hydrate
  // tous les details déjà ouverts.
  function retryHydration() {
    document.querySelectorAll('details[data-drawer-lvl1-handle][open]').forEach(hydrate);
  }
  if (typeof window.menuBhData !== 'object') {
    var iv = setInterval(function () {
      if (typeof window.menuBhData === 'object') { clearInterval(iv); retryHydration(); }
    }, 200);
    setTimeout(function () { clearInterval(iv); }, 8000);
  }
})();
